import { createSelector } from 'reselect';
import { getHasEditScope } from 'web-interactives-dashboard-ui/selectors/auth';
const getAppState = state => state.appState;
const createAppStateSelector = key => createSelector(getAppState, appState => appState[key]);
export const getRequestedEditorTour = createAppStateSelector('requestedEditorTour');
export const getCurrentPathParams = createAppStateSelector('pathParams');
export const getHasReadOnlyTestFlag = createAppStateSelector('readOnlyTestFlag');
export const getBaseRoute = createSelector(getCurrentPathParams, pathParams => pathParams[0]);
const createAppRouteSelector = route => createSelector(getBaseRoute, currentRoute => route === currentRoute);
export const getIsDetailsPage = createAppRouteSelector('details');
export const getIsAnalyzePage = createAppRouteSelector('analyze');
export const getIsManagePage = createAppRouteSelector('manage');
export const getIsCreatePage = createAppRouteSelector('create');
export const getIsReadOnly = createSelector([getHasReadOnlyTestFlag, getHasEditScope], (readOnlyFlag, writeAccess) => {
  return !writeAccess || readOnlyFlag;
});